import React, { useState } from 'react'
import objectToQueryParams from '../../../common/objectToQueryParams'
import Select from '../../../components/Common/Input/Select'

const SearchFilter = ({ setQueryParams, usersList, heading, loading=false }) => {

    const [userId, setUserId] = useState('')
    const [lafLanId, setLafLanId] = useState('')
    // const [loading, setLoading] = useState(false)

    const resetQueryParams = () => {
        setUserId('')
        setLafLanId('')
        let searchObject = {
            laf_id: '',
            user_id: ''
        }
        let queryString = objectToQueryParams(searchObject);
        setQueryParams(queryString)
    }

    const submitQueryParams = () => {
        // setLoading(true)
        let searchObject = {
            laf_id: lafLanId,
            user_id: userId?.value || ''
        }
        let queryString = objectToQueryParams(searchObject);
        setQueryParams(queryString)
        // setLoading(false)
    }

    return (
        <div className='tab panel overflow-unset mt-2 mb-0' >
            <form>
                <div className='p-2'>
                    <div className='row'>

                        <div className='col-md-4'>
                            <div className='form-group'>
                                <label>{(heading === 'cersai')? 'LAN ID' : 'LAF ID'}</label>
                                <input
                                    className='form-control'
                                    value={lafLanId}
                                    onChange={(e) => {
                                        setLafLanId(e.target.value.replace(/[_\W]+/g, ""))
                                    }}
                                />
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='form-group'>
                                <Select
                                    label='Uploaded By'
                                    options={usersList}
                                    onChange={(data) => setUserId(data)}
                                    value={userId}
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row d-flex'>
                        <div className='col-md-12 d-flex'>
                            <button
                                disabled={loading}
                                onClick={submitQueryParams}
                                type='button'
                                className='btn btn-custom btn-custom-height'
                                id='submitButton'
                            >
                                {loading ? <div className="loader"></div> : 'Search'}
                            </button>
                            <button
                                onClick={resetQueryParams}
                                type='button'
                                className='btn btn-custom btn-custom-height ml-2'
                            >
                                Reset All
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default SearchFilter